import { render } from "./ShopAdmin.vue?vue&type=template&id=749afff4"
import script from "./ShopAdmin.vue?vue&type=script&lang=js"
export * from "./ShopAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__